import { PillsTutorialVideoComponent } from './pills-tutorial-video/pills-tutorial-video.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormationDataItemComponent } from './formation-data-item/formation-data-item.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FeaturedCardItemComponent } from './featured-card-item/featured-card-item.component';
import { PillsTutorialCategoriesComponent } from './pills-tutorial-categories/pills-tutorial-categories.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    FormationDataItemComponent,
    PillsTutorialVideoComponent,
    FeaturedCardItemComponent,
    PillsTutorialCategoriesComponent,
  ],
  imports: [CommonModule, MaterialModule, TranslateModule, FlexLayoutModule],
  exports: [
    FormationDataItemComponent,
    PillsTutorialVideoComponent,
    FeaturedCardItemComponent,
    PillsTutorialCategoriesComponent,
  ],
})
export class TrainingSharedModule {}
